import React from 'react';
import Box from '../box';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useFooterContext } from './context';
/** Organizes Footer content into a row of multuple columns. */
const FooterRow = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Footer', useFooterContext());
    return React.createElement(Box, { className: cs('vui-footerRow', className), m: -1.5, ref: ref, wrap: true, ...styles.row, ...rest });
});
export default FooterRow;
